import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Form, Row, Col, Button, Card } from "react-bootstrap";

const FormatIVForm = forwardRef(({ formData, setFormData, vfcs }, ref) => {
  const [entries, setEntries] = useState(
    Array.isArray(formData.formatIV) ? formData.formatIV : []
  );

  useImperativeHandle(ref, () => ({
    validate: () => {
      return entries.every(
        (entry) =>
          entry.year &&
          entry.panchayat &&
          entry.workPending &&
          entry.reasonForDelay &&
          entry.amount >= 0 &&
          entry.orderAwaitedFromDept &&
          entry.nametapVillage
      );
    },
  }));

  const addEntry = () => {
    const updated = [
      ...entries,
      {
        year: "",
        panchayat: "",
        workPending: "",
        reasonForDelay: "",
        amount: 0,
        orderAwaitedFromDept: "",
        nametapVillage: "",
      },
    ];
    setEntries(updated);
    setFormData({ ...formData, formatIV: updated });
  };

  const handleEntryChange = (index, field, value) => {
    const updated = entries.map((entry, i) =>
      i === index ? { ...entry, [field]: value } : entry
    );
    setEntries(updated);
    setFormData({ ...formData, formatIV: updated });
  };
  const generateYearRanges = (startYear, endYear) => {
    const ranges = [];
    for (let year = startYear; year < endYear; year++) {
      ranges.push(`${year}-${year + 1}`);
    }
    return ranges;
  };

  const yearRanges = generateYearRanges(1999, new Date().getFullYear());
  return (
    <div>
      {entries.map((entry, index) => (
        <Card className="mb-3" key={index}>
          <Card.Body>
            <Row className="mb-2">
              <Col md={4}>
                <Form.Group controlId={`year-${index}`}>
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Year"
                    value={entry.year}
                    onChange={(e) =>
                      handleEntryChange(index, "year", e.target.value)
                    }
                  >
                    <option value="">Select Year</option>
                    {yearRanges.map((yr) => (
                      <option key={yr} value={yr}>
                        {yr}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId={`panchayat-${index}`}>
                  <Form.Label>Panchayat</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.panchayat}
                    onChange={(e) =>
                      handleEntryChange(index, "panchayat", e.target.value)
                    }
                    placeholder="Enter panchayat"
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId={`workPending-${index}`}>
                  <Form.Label>Work Pending</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.workPending}
                    onChange={(e) =>
                      handleEntryChange(index, "workPending", e.target.value)
                    }
                    placeholder="Enter pending work"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={6}>
                <Form.Group controlId={`reasonForDelay-${index}`}>
                  <Form.Label>Reason for Delay</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.reasonForDelay}
                    onChange={(e) =>
                      handleEntryChange(index, "reasonForDelay", e.target.value)
                    }
                    placeholder="Enter reason"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId={`amount-${index}`}>
                  <Form.Label>Amount (Rs.)</Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    value={entry.amount}
                    onChange={(e) =>
                      handleEntryChange(index, "amount", e.target.value)
                    }
                    placeholder="Amount"
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group controlId={`orderAwaitedFromDept-${index}`}>
                  <Form.Label>Awaiting Dept.</Form.Label>
                  <Form.Control
                    type="text"
                    value={entry.orderAwaitedFromDept}
                    onChange={(e) =>
                      handleEntryChange(
                        index,
                        "orderAwaitedFromDept",
                        e.target.value
                      )
                    }
                    placeholder="Enter department"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group controlId={`nametapVillage-${index}`}>
                  <Form.Label>Select VFC</Form.Label>
                  <Form.Control
                    as="select"
                    value={entry.nametapVillage}
                    onChange={(e) =>
                      handleEntryChange(index, "nametapVillage", e.target.value)
                    }
                  >
                    <option value="">-- Select VFC --</option>
                    {vfcs.map((vfc) => (
                      <option key={vfc._id} value={vfc._id}>
                        {vfc.vfcName}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}

      <Button variant="primary" onClick={addEntry}>
        Add Entry
      </Button>
    </div>
  );
});

export default FormatIVForm;
